import Api from '@/services/Index';

const getAll = (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/cards', config);
}

const printCard = (id, side = "") => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/cards/print/' + id + `?side=${side}`, {responseType: 'arraybuffer'});
}

const createCard = (id, side = "", fobNumber = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const params = { side };
    if (fobNumber) params.fob_number = fobNumber;
    return Api.get('/student/cards/create/' + id, { responseType: 'arraybuffer', params });
}

const updateFobNumber = (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/cards/fob-number/' + id, formData);
}

export default {
    getAll,
    printCard,
    createCard,
    updateFobNumber
}
